<template>
  <div class="comp-agency-tree-detail">
    <div class="content">
      <div class="panel">
        <div class="panel-heading">待选</div>
        <div class="panel-body">
          <AgencyTreeCore
            :content-height="260"
            ref="tree"
            :treeData="treeData"
            :hasFilter="false"
            :filter-node-method="handleFilterNode"></AgencyTreeCore>
        </div>
      </div>
      <el-button @click="handleSelect" class="select-btn" size="small" v-if="checkable">>></el-button>
      <div class="panel">
        <div class="panel-heading">
          已选 {{selectList.length}} 家
          <span class="clear-btn" @click="handleClear">清空</span>
        </div>
        <div class="select-container">
          <ul>
            <li v-for="(item,index) in selectList" :key="index">
              <span>{{item.name}}</span>
              <a href="javascript:void(0);" @click="handleDelSelect(index)" class="del-btn">删除</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import AgencyTreeCore from './AgencyTreeCore';
  import {findChild, flatern, getDataByHotelId, init} from './agencyUtils';

  export default {
    props: ['dataSource'],
    components: {
      AgencyTreeCore
    },
    data () {
      return {
        visible: false,
        checkable: this.$attrs.checkable === undefined || this.$attrs.checkable,
        selectList: [],
      };
    },
    created () {
      const orgTree = this.dataSource.map((item) => {
        return Object.assign({}, item);
      });
      let root = orgTree[0];
      root.children = findChild(orgTree, root.id);
      init();
      this.treeData = flatern(root, 0, -1);
    },
    methods: {
      handleFilterNode (data,filterText) {
        return data.name.indexOf(filterText) !== -1;
      },
      handleDelSelect (index) {
        this.selectList.splice(index, 1);
        const ids = this.selectList.map((item) => {
          return item.id;
        });
        this.$refs.tree.setAgency(ids);
        this.$emit('checkAgencyLeaves',this.selectList);
      },
      handleClear () {
        const waitIds = [];
        this.treeData.forEach((item) => {
          if (item.type === 3 && item.checkStatus.checked === 2) {
            waitIds.push(item.id);
          }
        });
        const alreadyIds = this.selectList.map((item) => {
          return item.id;
        });
        const ret = [];
        waitIds.forEach((waitId) => {
          if (alreadyIds.indexOf(waitId) === -1) {
            ret.push(waitId);
          }
        });
        this.$refs.tree.setAgency(ret);
        this.selectList = [];
        this.$emit('checkAgencyLeaves',this.selectList);
      },
      handleSelect (e) {
        const data = this.treeData.filter((item) => {
          return item.type === 3 && item.checkStatus.checked === 2;
        });
        if (data.length === 0) {
          this.$message.warning('请选择门店');
          return false;
        }
        this.selectList = data.filter((item) => {
          return item.type === 3 && item.checkStatus.checked === 2;
        });
        this.$emit('checkAgencyLeaves',this.selectList);
        return false;
      },
      handleNodeClick (agency) {
        this.selectList = [agency];
      },
      setAgency (agencies) {
        this.$refs.tree.setAgency(agencies);
        this.selectList = this.treeData.filter((item) => {
          return item.type === 3 && item.checkStatus.checked === 2;
        });
        this.$emit('checkAgencyLeaves',this.selectList);
      }
    }
  };
</script>

<style lang="less">
  .comp-agency-tree-detail {
    .title {
      height: 40px;
      line-height: 40px;
      padding-left: 20px;
      border-bottom: 1px solid #ebeef5;
      .close {
        float: right;
        margin-right: 20px;
        cursor: pointer
      }
    }
    .content {
      padding: 20px;
      .city-container {
        border: 1px solid #ddd;
        padding: 3px 5px;
        a {
          padding: 3px;
          color: #333;
        }
        a.active {
          color: #016cdf;
        }
      }
      .del-btn {
        float: right;
      }
      .select-item {
        text-decoration: none;
        font-size: 12px;
        color: #333333;
        letter-spacing: -0.29px;
        margin-left: 20px;
        cursor: pointer;
      }
      .select-item.active {
        color: #016cdf;
      }
      .el-form-item {
        margin-bottom: 2px !important;
      }
      .el-form-item__label {
        line-height: 36px;
      }
      .select-btn {
        display: inline-block;
        min-width: 30px;
        width: 30px;
        height: 30px;
        background: #016cdf;
        border-radius: 2px;
        border: 1px solid #d8d8d8;
        color: white;
        cursor: pointer;
        margin-top: 135px;
        span {
          margin-left: -6px;
        }
      }
      .panel {
        margin-top: 5px;
        display: inline-block;
        margin-bottom: 20px;
        background-color: #fff;
        border-radius: 4px;
        -webkit-box-shadow: 0 1px 1px rgba(0, 0, 0, .05);
        box-shadow: 0 1px 1px rgba(0, 0, 0, .05);
        width: 240px;
        vertical-align: top;
      }
      .panel-heading {
        font-size: 13px;
        color: #FFFFFF;
        letter-spacing: -0.29px;
        background: rgba(1, 108, 223, 0.80);
        border-color: #ddd;
        line-height: 22px;
        height: 22px;
        padding: 4px 0 4px 14px;
        .clear-btn {
          float: right;
          cursor: pointer;
          padding: 0 20px;
        }
      }
      .panel-body {
        border: 1px solid #ddd;
        height: 285px;
        overflow-y: hidden;
      }
      .select-container {
        border: 1px solid #ddd;
        height: 270px;
        padding: 8px;
        overflow-y: auto;
      }
      .btn-area {
        text-align: center;
      }
      .el-tree-node__label {
        width: 160px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// AgencyTreeDetail.vue?57b8ca62